import { render } from "./AddEvent.vue?vue&type=template&id=0649f88e&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"

import "./AddEvent.vue?vue&type=style&index=0&id=0649f88e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0649f88e"

export default script